// removed by extract-text-webpack-plugin
module.exports = {"modal":"SessionTimerModal__modal","modalContent":"SessionTimerModal__modalContent"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/SessionTimerModal/SessionTimerModal.scss
// module id = 1731
// module chunks = 8